var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrappNextCompetition"},[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('competitions.main.competitionNext')+' "' + _vm.data.cmp_theme + '"')+"\n  ")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.cmp_description))]),_c('div',{staticClass:"subTitle"},[_vm._v("\n    "+_vm._s(_vm.$t('competitions.main.duration') +
        _vm.$moment
          .utc(_vm.data.cmp_from_post)
          .local()
          .format('DD.MM.YYYY. HH:mm') + ' '+
      _vm.$t('competitions.main.until') + ' ' +
        _vm.$moment
          .utc(_vm.data.cmp_to_vote)
          .local()
          .format('DD.MM.YYYY. HH:mm') +
      _vm.$t('competitions.main.hours') +'.')+"\n  ")]),_c('ul',[_c('li',[_vm._v("\n      "+_vm._s(_vm.$t('competitions.main.sendingReceiving') +
          _vm.$moment
            .utc(_vm.data.cmp_from_post)
            .local()
            .format('DD.MM.YYYY. HH:mm') + ' '+
            _vm.$t('competitions.main.until') + ' ' +
          _vm.$moment
            .utc(_vm.data.cmp_to_post)
            .local()
            .format('DD.MM.YYYY. HH:mm') +
            _vm.$t('competitions.main.hours'))+"\n    ")]),_c('li',[_vm._v("\n      "+_vm._s(_vm.$t('competitions.main.voteStart') +
          _vm.$moment
            .utc(_vm.data.cmp_from_vote)
            .local()
            .format('DD.MM.YYYY. HH:mm') +
          _vm.$t('competitions.main.hoursTo') +
          _vm.$moment
            .utc(_vm.data.cmp_to_vote)
            .local()
            .format('DD.MM.YYYY. HH:mm') +
          _vm.$t('competitions.main.hours'))+"\n    ")]),_c('li',[_vm._v("\n     "+_vm._s(_vm.$t('competitions.tr.termsConditions'))+"\n      "),_c('router-link',{attrs:{"to":{
          name: 'CompetitionRules',
          params: { id: _vm.data.cmp_id }
        }}},[_vm._v(_vm._s(_vm.$t('competitions.tr.here')))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }